import React, { memo, useCallback, useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { BiCog } from "react-icons/bi";
import { BsPeople, BsToggles } from "react-icons/bs";
import {
	IoDocumentTextOutline,
} from "react-icons/io5";
import {
	MdBlock,
	MdLightbulbOutline,
	MdOutlineCategory,
	MdOutlineCloudDownload,
	MdOutlineMapsHomeWork,
	MdWebhook,
} from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { useListManager } from "../../contexts/list.manager";
import { useUserStore } from "../../contexts/userStore";
import MenuLine from "../MenuLine/MenuLine";
import "./MenuBar.css";
import { LuTags, LuUser, LuUsers, LuClock, LuFileBadge, LuRouteOff, LuUserPlus, LuRoute, LuChartBar, LuActivity, LuTriangleAlert, LuBox } from "react-icons/lu";
import { GiHamburgerMenu } from "react-icons/gi";
import Logo from "../Logo/Logo";
import { LicenseSelector } from "../LicenseSelector/LicenseSelector";
import { useBackup } from "../../contexts/backup";
import { UserBar } from "../UserBar/UserBar";
import { TbBuildingCommunity, TbUserShield, TbBellCog, TbReportAnalytics, TbCornerUpRightDouble, TbRosetteDiscount } from "react-icons/tb";
import { DynamicIcon } from "../DynamicIcon/DynamicIcon";
import { capitalize, pluralizePortuguese } from "../../utils/string";
import { RiEye2Line } from "react-icons/ri";
import { GoArrowSwitch } from "react-icons/go";
import { IdCardLanyard, ScrollText, ShieldCheck } from "lucide-react";
import { PiSecurityCameraBold } from "react-icons/pi";
import { MenuItemsGroup } from "./MenuItemsGroup";
import { useTranslation } from "react-i18next";
import { LicenseAlert } from "../LicenseAlert/LicenseAlert";
import { countFieldArray } from "../../utils/array";

const licensesRoutesData = (selectedOrganization = false) => ({
	action: "bravas.accessControl.license.detailed.getPaginated",
	title: "menu.licenses",
	route: "../consulta-licencas-new",
	routes: ["../cadastro-licencas-new"],
	icon: <LuFileBadge size={20} />,
	submenu: [
		{
			action: "bravas.accessControl.license.analytics",
			title: "menu.overview",
			route: "../licenses-overview",
			icon: <LuChartBar size={18} />,
			routes: [],
		},
		{
			action: "bravas.accessControl.license.detailed.getPaginated",
			title: "menu.allLicenses",
			route: "../licenses",
			icon: <LuActivity size={18} />,
			routes: [],
		},
		{
			action: "bravas.accessControl.license.detailed.getPaginated",
			title: "menu.requiresAttention",
			route: "../licenses/attention",
			icon: <LuTriangleAlert size={18} />,
			routes: [],
		},
		{
			action: "bravas.accessControl.license.detailed.getPaginated",
			title: "menu.blocked",
			route: "../licenses/blocked",
			icon: <MdBlock size={18} />,
			routes: [],
		},
		{
			action: "bravas.accessControl.license.detailed.getPaginated",
			title: "menu.stock",
			route: "../licenses/stock",
			icon: <LuBox size={18} />,
			routes: [],
		},
		{
			action: "bravas.accessControl.license.feature.getPaginated",
			title: "menu.licenseFeatures",
			route: "../licenses/features",
			icon: <BsToggles size={18} />,
			routes: [
				"../licenses/features/new",
				"../licenses/features/",
			],
		},
		{
			action: "bravas.accessControl.license.type.getPaginated",
			title: "menu.licenseTypes",
			route: "../licenses/types",
			icon: <MdOutlineCategory size={18} />,
			routes: [
				"../licenses/types/new",
				"../licenses/types/",
			],
		},
		{
			action: "bravas.accessControl.license.discountReason.getPaginated",
			title: "menu.discountReasons",
			route: "../licenses/discount-reasons",
			icon: <TbRosetteDiscount size={18} />,
			routes: [
				"../licenses/discount-reasons/new",
				"../licenses/discount-reasons/",
			],
		},
	]
});

export const routesData = [
	{
		groupLabel: '',
		items: [
			{
				action: "bravas.accessControl.general.reception",
				title: "menu.monitoring",
				route: "../monitoramento/portaria",
				routes: ["../monitoramento/portaria", "../monitoramento/alarmes", "../monitoramento/permanencia", "../monitoramento/acessos"],
				icon: <RiEye2Line size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.events.device.getByModulePaginated",
				title: "menu.reports",
				route: "../historico-eventos",
				icon: <ScrollText size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.accessControl.accessModule.getPaginated",
				title: "menu.access",
				route: "../consulta-access-points",
				routes: ["../cadastro-access-points", "../access-points"],
				icon: <GoArrowSwitch size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.accessControl.reader.getPaginated",
				title: "menu.readers",
				route: "../consulta-readers",
				routes: ["../cadastro-readers", "../readers", "../configuracoes-gerais-leitoras"],
				icon: <PiSecurityCameraBold size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.accessControl.interlock.getPaginated",
				title: "menu.interlocks",
				route: "../consulta-interlocks",
				routes: ["../cadastro-interlocks", "../interlocks"],
				icon: <LuRouteOff size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.accessControl.antiPassback.getPaginated",
				title: "menu.antiPassbacks",
				route: "../consulta-anti-passbacks",
				routes: ["../cadastro-anti-passbacks", "../anti-passbacks"],
				icon: <TbCornerUpRightDouble size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.accessControl.automationButton.getPaginated",
				title: "menu.automation",
				route: "../consulta-automation-buttons",
				routes: ["../cadastro-automation-buttons", "../automation-buttons"],
				icon: <MdLightbulbOutline size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			},
			{
				action: "bravas.backup.management.list",
				title: "menu.backups",
				route: "../consulta-backups",
				routes: ["../cadastro-backups"],
				icon: <MdOutlineCloudDownload size={20} />,
				condition: 'selectedOrganization',
				selectedOrganization: true,
				selectedUnit: true,
				enabledBackup: true,
			},
			{
				action: "bravas.backup.management.list",
				title: "menu.history",
				route: "../relatorios/historico-modulos-de-acessos",
				routes: ["../relatorios/historico-modulos-de-acessos"],
				icon: <TbReportAnalytics size={20} />,
				condition: 'selectedOrganization',
				selectedOrganization: true,
				selectedUnit: true,
			},
		]
	},
	{
		groupLabel: 'menu.administration',
		items: [
			{
				action: "bravas.apiGateway.log.getPaginated",
				title: "menu.logs",
				route: "../logs",
				icon: <IoDocumentTextOutline size={20} />,
				selectedOrganization: false,
			},
			licensesRoutesData(),
			{
				action: "bravas.identity.organization.getPaginated",
				title: "menu.clients",
				route: "../consulta-clientes",
				routes: ["../cadastro-clientes"],
				icon: <BsPeople size={20} />,
				selectedOrganization: false,
			},
		]
	},
	{
		groupLabel: 'menu.multiLicense',
		items: [
			{
				action: "bravas.accessControl.group.getPaginated",
				title: "menu.groups",
				route: "../consulta-access-groups",
				routes: ["../cadastro-access-groups", "../access-groups"],
				icon: <LuUsers size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
			},
			{
				action: "bravas.accessControl.user.getPaginated",
				title: "menu.users",
				route: "../consulta-condo-users",
				routes: ["../cadastro-condo-users", "../device-users"],
				icon: <LuUser size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
			},
			{
				action: "bravas.accessControl.user.getPaginated",
				title: "menu.invitations",
				route: "../consulta-invitations",
				routes: ["../cadastro-invitations", "../invitations"],
				icon: <LuUserPlus size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
			},
			{
				action: "bravas.accessControl.group.getPaginated",
				title: "menu.routes",
				route: "../consulta-access-routes",
				routes: ["../cadastro-access-routes", "../access-routes"],
				icon: <LuRoute size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
			},
		]
	},
	{
		groupLabel: 'menu.general',
		items: [
			{
				action: ["bravas.accessControl.license.getPaginated", "bravas.identity.unit.getByOrganization"],
				title: "menu.myLicenses",
				route: "../licencas",
				icon: <LuFileBadge size={20} />,
				condition: 'selectedOrganization',
				selectedOrganization: true,
			},
			{
				action: "bravas.identity.unit.getPaginated",
				title: "menu.organization",
				route: "../consulta-condominios",
				routes: ["../cadastro-condominios", "../condominios"],
				icon: <TbBuildingCommunity size={20} />,
				condition: 'selectedOrganization',
				selectedOrganization: true,
			},
			{
				action: "bravas.identity.tag.getPaginated",
				title: "menu.tags",
				route: "../consulta-tags",
				routes: ["../cadastro-tags", "../tag"],
				icon: <LuTags size={20} />,
			},
			{
				action: "bravas.identity.organization.partialUpdate",
				title: "menu.configurations",
				route: "../configuracoes/dados-cadastrais",
				routes: ["../configuracoes/email", "../configuracoes/webhooks", "../configuracoes/dados-cadastrais"],
				icon: <BiCog size={19} />,
				selectedOrganization: true,
				rootUnitAccess: true,
			},
		]
	},
	{
		groupLabel: 'menu.cloudAccessControl',
		items: [
			{
				action: "bravas.identity.shift.getPaginated",
				title: "menu.shifts",
				route: "../consulta-turnos",
				routes: ["../cadastro-turnos", "../turnos"],
				icon: <LuClock size={20} />,
				condition: 'selectedOrganization',
				selectedOrganization: true,
			},
			{
				action: "bravas.accessManagement.policy.getPaginated",
				title: "menu.accessPolicies",
				route: "../consulta-politicas-de-acesso",
				routes: ["../cadastro-politicas", "../politicas"],
				icon: <ShieldCheck size={20} />,
			},
			{
				action: "bravas.accessManagement.role.getPaginated",
				title: "menu.roles",
				route: "../consulta-papeis",
				routes: ["../cadastro-papeis", "../papeis"],
				icon: <IdCardLanyard size={22} />,
			},
			{
				action: "bravas.accessManagement.group.getPaginated",
				title: "menu.groups",
				route: "../consulta-grupos",
				routes: ["../cadastro-grupos", "../grupos"],
				icon: <LuUsers size={20} />,
			},
			{
				action: "bravas.identity.person.getPaginated",
				title: "menu.persons",
				route: "../consulta-operadores",
				routes: ["../cadastro-operadores", "../pessoa"],
				icon: <LuUser size={20} />,
			},
			{
				action: "bravas.accessManagement.user.getPaginated",
				title: "menu.cloudUsers",
				route: "../consulta-users",
				routes: ["../cadastro-users", "../users"],
				icon: <TbUserShield size={20} />,
			},
		]
	},
	// {
	// 	groupLabel: 'menu.integrations',
	// 	items: [
	// 		{
	// 			action: "bravas.notifier.webhook.getPaginated",
	// 			title: "menu.webhooks",
	// 			route: "../consulta-webhooks",
	// 			routes: ["../cadastro-webhooks", "../webhooks"],
	// 			icon: <MdWebhook size={19} />,
	// 			selectedOrganization: true,
	// 		},
	// 		{
	// 			action: "bravas.notifier.configuration.save",
	// 			title: "menu.configurations",
	// 			route: "../configuracoes-notificador",
	// 			icon: <TbBellCog size={19} />,
	// 			selectedOrganization: true,
	// 		},
	// 	],
	// }
];

export function filterAllowedRoutes(userData, licences, selectedLicenceObj, items, can) {
	return items?.filter((menu) => {
		const policyMatch = userData.isSuperAdmin || !menu.action || can?.(menu.action);
		let selectionsMatch = true;
		if (menu.selectedOrganization !== undefined) {
			if (
				(menu.selectedOrganization && (!userData.selectedOrganizationId)) ||
				(!menu.selectedOrganization && userData.selectedOrganizationId)
			) {
				selectionsMatch = false;
			}
		}
		if (menu.selectedUnit !== undefined && licences !== undefined) {
			if (menu.selectedUnit && licences.length === 0) {
				selectionsMatch = false;
			}
		}
		if (menu.enabledBackup !== undefined && menu.enabledBackup !== selectedLicenceObj?.enabledBackup) {
			selectionsMatch = false;
		}
		if (menu.rootUnitAccess && !userData.isSuperAdmin && !userData.hasRootUnitAccess) {
			selectionsMatch = false;
		}
		// const policyMatch = true || !menuItem.condition || user.userData[menuItem.condition];
		return policyMatch && selectionsMatch;
	})
}

const MenuBar = memo((props) => {
	const { user, can } = useAuth();
	const { backup } = useBackup();
	const { condominiums, licences, selectedLicenceObj, selectingUnit, selectedCondominio, selectedCondominioObj } = useUserStore();
	const { closeForm } = useListManager();
	const [isCollapsed, setIsCollapsed] = useState(false);
	const [navWidth, setNavWidth] = useState("286px");
	const [pageSelected, setPageSelected] = useState("");
	const [optionsCondominios, setOptionsCondominios] = useState([]);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { t } = useTranslation();

	useEffect(() => {
		if (user.userData.selectedOrganizationId && condominiums.length) {
			const options = condominiums?.filter(unit => unit.organizationId === user.userData.selectedOrganizationId).map((condominium) => ({
				value: condominium.id,
				text: condominium.name,
			}));
			setOptionsCondominios(options);
		} else {
			setOptionsCondominios([]);
		}
	}, [user.userData, condominiums]);

	const arrowClick = useCallback(() => {
		if (document.documentElement.clientWidth < 1024) {
			props.hideMenu();
			return;
		}
		setIsCollapsed((prev) => !prev);
		setNavWidth((prevWidth) => (prevWidth === "286px" ? "78px" : "286px"));
	}, [props]);

	const handleNavigation = useCallback(
		(route) => {
			closeForm();
			navigate(route, { replace: true });
			if (document.documentElement.clientWidth < 1024) {
				props.hideMenu();
			}
		},
		[closeForm, navigate, props]
	);

	useEffect(() => {
		setPageSelected(`..${pathname}`);
	}, [pathname])

	function mountDinamycRoutes() {
		const unitTags = new Map();

		user.userData.selectedUnit?.tags?.forEach(tag => {
			tag.scopeTags?.forEach(scopeTag => {
				if (scopeTag.type === 'UNIT' && scopeTag.sendToDevices === true) {
					unitTags.set(scopeTag.externalId, scopeTag);
				}
			});
		});

		return unitTags.entries()?.map(([_, tag]) => (
			{
				action: "bravas.identity.unit.getPaginated",
				title: capitalize(pluralizePortuguese(tag.name)),
				route: `../consulta-units/${tag.externalId}`,
				routes: [`../cadastro-units/${tag.externalId}`, `../units/${tag.externalId}`, `../cadastro-batch-units/${tag.externalId}`],
				icon: tag.icon ? <DynamicIcon iconName={tag.icon} size={19} /> : <MdOutlineMapsHomeWork size={20} />,
				condition: 'selectedUnit',
				selectedOrganization: true,
				selectedUnit: true,
			}
		)) || [];
	}

	const renderMenus = () => {
		const _routes = [
			...routesData.map(data => Object.assign({}, data))
		];
		_routes[0].items = [
			...routesData[0].items,
			...mountDinamycRoutes(),
		];
		const menu = _routes.map(group => ({
			...group,
			items: [
				...(
					filterAllowedRoutes(user.userData, licences, selectedLicenceObj, group.items, can)
						.map(item => ({
							...item,
							submenu: item.submenu ? filterAllowedRoutes(user.userData, licences, selectedLicenceObj, item.submenu, can) : null,
						}))
				),
			]
		}));
		return menu.filter(group => group.items && group.items.length > 0);
	};

	const menus = renderMenus();

	const mobileMenuClick = () => {
		props.handleMobileMenuClick();
	};

	const isSelectedUnitSubOrganization = selectedCondominioObj?.isSubOrganization ?? false;
	let urlLogo = null;

	if (isSelectedUnitSubOrganization || user.userData.selectedSubOrganization || user.userData.selectedOrganization) {
		urlLogo = isSelectedUnitSubOrganization ? selectedCondominioObj.urlLogo : (user.userData.selectedSubOrganization?.urlLogo ?? user.userData.selectedOrganization.urlLogo);
	}

	return (
		<React.Fragment>
			<div className={`sidenav shadow-xl! ${props.className} ${isCollapsed ? 'sidenav-collapsed' : ''}`} style={{ width: navWidth, height: '100vh', zIndex: '40' }}>
				<div style={{ display: 'flex', flexDirection: 'column', position: 'relative', height: '100vh', overflowY: 'hidden', overflowX: 'hidden' }}>
					<div className="sidenav-header">
						<IconContext.Provider value={{ className: "mobile-menu-icon" }}>
							<GiHamburgerMenu
								onClick={() => mobileMenuClick()}
								size={25}
								color="#0C86C6"
							/>
						</IconContext.Provider>
						<Link to={"../selecione-organizacao"}>
							{(isSelectedUnitSubOrganization || user.userData.selectedSubOrganization || user.userData.selectedOrganization) ? (
								<Logo
									cached={true}
									cacheKey={`organization-logo`}
									showIcon={isCollapsed}
									imgId={urlLogo}
									alt="logo"
									className={`header-bar-logo ${urlLogo ? '' : 'header-bar-logo-cloud'}`}
								/>
							) : (
								<Logo
									showIcon={isCollapsed}
									alt="Logo Cloud"
									className="header-bar-logo header-bar-logo-cloud"
								/>
							)}
						</Link>
						<button type="button" className={`sidenav-hide-container ${isCollapsed ? 'sidenav-hide-container-collapsed' : 'sidenav-hide-container-expanded'} group`} onClick={arrowClick} >
							<IconContext.Provider value={{ className: "sidenav-hide-icon" }}>
								<svg
									width={20}
									height={20}
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="text-f1-icon-bold text-(--textColor)"
								>
									<rect
										id="container"
										x="3.33325"
										y={5}
										width="14"
										height={10}
										rx={3}
										strokeWidth="1.3"
										className="stroke-current"
									/>
									{navWidth === "286px" ? (
										<>
											<path
												id="arrow"
												d="M10.417 10L14.167 10M10.417 10L12.0837 8.33337M10.417 10L12.0837 11.6667"
												strokeWidth="1.3"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="translate-x-1 top-px stroke-current transition-all duration-200 ease-out motion-reduce:transition-none opacity-0 group-hover:-translate-x-1 group-hover:opacity-100"
											/>
											<path
												id="line"
												d="M7.5 5L7.5 15"
												strokeWidth="1.3"
												strokeLinecap="round"
												className="stroke-current transition-all duration-200 ease-out motion-reduce:transition-none translate-x-[0.11rem] opacity-100 group-hover:-translate-x-0.5 group-hover:opacity-0"
											/>
										</>
									) : (
										<>
											<path
												id="arrow"
												d="M10.417 10L14.167 10M10.417 10L12.0837 8.33337M10.417 10L12.0837 11.6667"
												strokeWidth="1.3"
												strokeLinecap="round"
												strokeLinejoin="round"
												className="-translate-x-1 origin-center rotate-180 stroke-current transition-all duration-200 ease-out motion-reduce:transition-none opacity-0 group-hover:translate-x-1 group-hover:opacity-100"
											/>
											<path
												id="line"
												d="M7.5 5L7.5 15"
												strokeWidth="1.3"
												strokeLinecap="round"
												className="stroke-current transition-all duration-200 ease-out motion-reduce:transition-none -translate-x-0.5 opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
											/>
										</>
									)}
								</svg>
							</IconContext.Provider>
						</button>
					</div>

					<div style={{ position: 'relative', flex: 1, marginBottom: '74px', zIndex: 21, overflowY: 'auto', overflowX: 'hidden' }}>
						<div className={`${menus.filter(group => !group.groupLabel).reduce((prev, cur) => prev + cur.items.length, 0) > 0 ? 'selected-unit-menu' : 'selected-unit-menu selected-unit-menu-empty'} ${!selectedCondominio ? 'opacity-0!' : ''} ${optionsCondominios?.length > 0 ? '' : 'none-unit'}`}>
							{optionsCondominios.length > 0 && (
								<LicenseSelector collapsed={isCollapsed ?? false} />
							)}
							{selectedCondominio && (
								<>
									<LicenseAlert onlyIcon={isCollapsed} className="mb-1.5!" unit={selectedCondominio} />
									{menus.filter(group => !group.groupLabel).map((group, idx) => (
										<div key={idx} style={{ marginTop: isCollapsed ? '10px' : 0, padding: '0 8px' }}>
											<div className="flex flex-col gap-1!">
												{group.items.map((menu, index) => (
													<MenuLine
														key={index}
														index={String.fromCharCode(65 + index)}
														title={t(menu.title)}
														route={menu.route}
														routes={menu.routes}
														handleClick={() => handleNavigation(menu.route)}
														icon={menu.icon}
														navWidth={navWidth}
														pageSelected={pageSelected}
														disabled={
															selectingUnit ||
															(menu.selectedUnit === true &&
																backup &&
																backup.status === 4 &&
																backup.currentStage < backup.totalImportingStages)
														}
													/>
												))}

											</div>
										</div>
									))}
								</>
							)}
						</div>

						{menus.filter(group => group.groupLabel).map((group, idx) => (
							<MenuItemsGroup
								key={idx}
								groupIndex={(countFieldArray(menus.filter(group => group.groupLabel)?.slice(0, idx), 'items') ?? 0)}
								group={group}
								navWidth={navWidth}
								pageSelected={pageSelected}
								backup={backup}
								isCollapsed={isCollapsed}
								handleNavigation={handleNavigation} />
						))}
					</div>
				</div>

				<UserBar isCollapsed={isCollapsed} />
			</div>
		</React.Fragment >
	);
});

export default MenuBar;
